import React from 'react';
import { Paper, Stack, Typography, Box } from '@mui/material';

// การ์ดพื้นฐานที่ใช้ร่วมกันทุกจุดในโมดูล marketing — หัวการ์ดมีแถบสี tint จาง ๆ ของ
// accentColor คั่นจากเนื้อหา ให้แต่ละหมวดมีเอกลักษณ์สีตัวเองชัดเจนกว่าเส้นขอบเปล่า ๆ
// เดิม (เช่น ข้อมูลทั่วไป=indigo, ผลปิดงาน=เขียว, เอกสาร=ส้ม/ฟ้า) ยกขึ้นเบา ๆ ตอน hover
export function SectionCard({
  icon, title, action, accentColor = 'primary.main', dense, sx, children,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        overflow: 'hidden',
        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
        '&:hover': {
          boxShadow: '0 12px 24px -12px rgba(15, 23, 42, 0.18)',
        },
        ...sx,
      }}
    >
      {(title || action) && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            px: dense ? 2 : 2.5,
            py: dense ? 1.25 : 1.75,
            bgcolor: (theme) => {
              // accentColor รับได้ทั้ง theme path ("primary.main") และ hex ตรงๆ ("#3b82f6") — hex
              // ใช้เวลาต้องการสีที่ไม่มีใน theme.palette เป๊ะๆ (เช่น สีสถานะของ marketing ที่ดึงจาก
              // getStatusHex ใน constants/status.js)
              const base = accentColor.startsWith('#')
                ? accentColor
                : (accentColor.split('.').reduce((acc, k) => acc?.[k], theme.palette) || theme.palette.primary.main);
              return theme.palette.mode === 'light' ? `${base}14` : `${base}26`;
            },
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            {icon && (
              <Box sx={{ display: 'flex', color: accentColor, '& svg': { fontSize: 20 } }}>
                {icon}
              </Box>
            )}
            <Typography variant="subtitle2" fontWeight={700} sx={{ letterSpacing: 0.1 }}>
              {title}
            </Typography>
          </Stack>
          {action}
        </Stack>
      )}
      <Box sx={{ p: dense ? 2 : 2.5 }}>
        {children}
      </Box>
    </Paper>
  );
}

export default SectionCard;
